import { render, staticRenderFns } from "./HelpDeskAutoPlay.vue?vue&type=template&id=8f49b4b4"
import script from "./HelpDeskAutoPlay.vue?vue&type=script&lang=js"
export * from "./HelpDeskAutoPlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports